(() => {
  function init(root = document) {
    root.querySelectorAll('[data-br-blog]').forEach(blog => {
      if (blog.dataset.initialized) return;
      blog.dataset.initialized = 'true';
      const posts = [...blog.querySelectorAll('[data-br-post]')];
      const buttons = [...blog.querySelectorAll('[data-br-category]')];
      const input = blog.querySelector('[data-br-search]');
      if (!input) return;
      const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('sr');
      let category = '';
      function apply() {
        const query = normalize(input.value.trim());
        let count = 0;
        posts.forEach(post => {
          const matches = (!category || JSON.parse(post.dataset.tags).includes(category)) && normalize(post.dataset.search).includes(query);
          post.hidden = !matches;
          if (matches) count++;
        });
        buttons.forEach(button => {
          const active = button.dataset.brCategory === category;
          button.classList.toggle('on', active);
          button.setAttribute('aria-pressed', String(active));
        });
        blog.querySelector('[data-br-empty]').hidden = count > 0;
        blog.querySelector('[data-br-results]').textContent = `Prikazano članaka: ${count}`;
      }
      function readHash() {
        let value = '';
        try { value = decodeURIComponent(location.hash.slice(1)); } catch { /* Invalid hash: show all. */ }
        category = buttons.some(button => button.dataset.brCategory === value) ? value : '';
        apply();
      }
      buttons.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.brCategory;
        history.replaceState(null, '', location.pathname + location.search + (category ? '#' + encodeURIComponent(category) : ''));
        apply();
      }));
      input.addEventListener('input', apply);
      blog.querySelector('[data-br-reset]').addEventListener('click', () => {
        category = '';
        input.value = '';
        history.replaceState(null, '', location.pathname + location.search);
        apply();
        input.focus();
      });
      window.addEventListener('hashchange', readHash);
      readHash();
    });
    root.querySelectorAll('[data-br-article]').forEach(article => {
      if (article.dataset.initialized) return;
      article.dataset.initialized = 'true';
      const content = article.querySelector('[data-br-content]');
      const toc = article.querySelector('[data-br-toc]');
      const headings = [...content.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `br-heading-${index + 1}`;
          while (document.getElementById(id)) id += '-rs';
          heading.id = id;
        }
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent;
        toc.append(link);
      });
      if (!headings.length) toc.parentElement.hidden = true;
      const progress = article.querySelector('[data-br-progress]');
      let scheduled = false;
      const update = () => {
        scheduled = false;
        const rect = content.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        progress.style.width = `${Math.max(0, Math.min(100, -rect.top / distance * 100))}%`;
        let current = headings[0];
        headings.forEach(heading => { if (heading.getBoundingClientRect().top <= 120) current = heading; });
        [...toc.children].forEach((link, index) => link.classList.toggle('on', headings[index] === current));
      };
      const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      update();
      article.querySelector('[data-br-copy]').addEventListener('click', async () => {
        const status = article.querySelector('[data-br-copy-status]');
        const url = document.querySelector('link[rel="canonical"]')?.href || location.href;
        try { await navigator.clipboard.writeText(url); status.textContent = 'Link je kopiran.'; }
        catch { status.textContent = 'Kopirajte adresu iz trake pregledača.'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
